import { combineReducers, legacy_createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from '@redux-devtools/extension'

import basketReducer from '../redux/store/Basket'
import orderReducer from '../redux/store/orderWay'

const loggerMiddleware = createLogger({
  diff: true
}) 

const store = legacy_createStore(combineReducers({
    basket: basketReducer,
    orderWay: orderReducer
  }),
  composeWithDevTools(applyMiddleware(loggerMiddleware))
)

export default store